import { Box } from '@material-ui/core';
import { LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { MetricsTypeToggle } from '@/components/modules/Metrics/shared/components/MetricsTypeToggle';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

import { TimeIntervalSelector } from '../../MetricAggregateViews/components/TimeIntervalSelector';
import { TimeInterval } from '../../shared/entities/TimeInterval';
import { ScoreCardMetricKey } from '../../shared/types/ScoreCardMetricKey';
import { TimeIntervalType } from '../../shared/types/TimeIntervalType';
import { loanStatusExternalValues } from '../constants/LoanStatusExternalValues';
import { metricsTypeValues } from '../constants/MetricsTypesValues';
import { StyledSelector } from './StyledSelector';

interface MetricsControllersAltProps {
  selectedMetricsType?: ScoreCardMetricKey;
  setSelectedMetricsType?: React.Dispatch<React.SetStateAction<ScoreCardMetricKey>>;
  timeInterval: TimeInterval;
  setTimeInterval: React.Dispatch<React.SetStateAction<TimeInterval>>;
  selectedLoanStatusExternal?: LoanStatusExternal;
  setSelectedLoanStatusExternal?: React.Dispatch<React.SetStateAction<LoanStatusExternal>>;
}

export const MetricsControllers = ({
  selectedLoanStatusExternal,
  setSelectedLoanStatusExternal,
  selectedMetricsType,
  setSelectedMetricsType,
  timeInterval,
  setTimeInterval,
}: MetricsControllersAltProps) => {
  const { sm } = useScreen();
  const { background } = useCustomTheme();

  const comparisonTextId =
    timeInterval.type === TimeIntervalType.MONTH_TO_DATE
      ? 'METRICS_COMPARISON_MONTH_TO_DATE'
      : timeInterval.days === 1
      ? 'METRICS_COMPARISON_PREVIOUS_DAY'
      : 'METRICS_COMPARISON_PREVIOUS_DAYS';

  return (
    <Box
      style={{
        zIndex: 12,
        top: !sm ? '70px' : '76px',
        position: 'sticky',
        marginBottom: '20px',
        backgroundColor: background,
      }}
    >
      <Box display={'flex'} flexWrap={'wrap'} alignItems={'center'} gridGap={8} py={1}>
        <TimeIntervalSelector type={'select'} timeInterval={timeInterval} setTimeInterval={setTimeInterval} />
        <Font variant="caption" color="textSecondary" style={{ marginLeft: '12px' }}>
          <Text tId={comparisonTextId} dynamicDataTexts={[String(timeInterval.days)]} />
        </Font>
        {setSelectedMetricsType && selectedMetricsType && (
          <MetricsTypeToggle
            options={metricsTypeValues}
            selectedMetricsType={selectedMetricsType}
            setSelectedMetricsType={setSelectedMetricsType}
          />
        )}
        {setSelectedLoanStatusExternal && selectedLoanStatusExternal && (
          <StyledSelector
            currentSelectedValue={selectedLoanStatusExternal}
            setSelectedValue={setSelectedLoanStatusExternal}
            startIcon={'filter_alt'}
            selectOptions={loanStatusExternalValues}
          />
        )}
      </Box>
    </Box>
  );
};
